import React, { FC } from 'react'

// MUI
import { Box, Container, Grid } from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import SavingsIcon from '@mui/icons-material/Savings'
import StarBorderIcon from '@mui/icons-material/StarBorder'

// SVG Icon
import { AwardWinningIcon } from '@/icons'

// UI
import { PaddTwentyFour } from '@/ui'
import { IconBgDiv, SectionHeadH2, SubDiv, SubTitleP, TitleH3, WhyChooseUsDiv } from './styles'

const WhyChooseUsSection: FC = () => {
  return (
    <WhyChooseUsDiv>
      <Container maxWidth="xl">
        <PaddTwentyFour>
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ mb: 5 }}>
              <SectionHeadH2>why choose us</SectionHeadH2>
            </Box>

            <Grid container justifyContent="space-between" alignItems={{ md: 'center', xs: 'flex-start' }} spacing={4}>
              <Grid item xs={6} sm={4} md={3}>
                <SubDiv>
                  <IconBgDiv>
                    <AccessTimeIcon />
                  </IconBgDiv>

                  <TitleH3>always available</TitleH3>
                  <SubTitleP>We accept requests and phone calls 24/7 so you could resolve any problem. Our emergency team will be at your place.</SubTitleP>
                </SubDiv>
              </Grid>
              <Grid item xs={6} sm={4} md={3}>
                <SubDiv>
                  <IconBgDiv>
                    <AwardWinningIcon />
                  </IconBgDiv>

                  <TitleH3>Qualified Workers</TitleH3>
                  <SubTitleP>All our team members are high-qualified, educated and skilled agents. All of them are being trained according to the latest.</SubTitleP>
                </SubDiv>
              </Grid>
              <Grid item xs={6} sm={4} md={3}>
                <SubDiv>
                  <IconBgDiv>
                    <SavingsIcon />
                  </IconBgDiv>

                  <TitleH3>Fair Prices</TitleH3>
                  <SubTitleP>Our prices are both fair and affordable for all people. We offer flexible discount system so you could use any service you need.</SubTitleP>
                </SubDiv>
              </Grid>
              <Grid item xs={6} sm={4} md={3}>
                <SubDiv>
                  <IconBgDiv>
                    <StarBorderIcon />
                  </IconBgDiv>

                  <TitleH3>Best Offers</TitleH3>
                  <SubTitleP>We provide discounts on the most popular services and on the season services, so you could definitely receive any help without delay.</SubTitleP>
                </SubDiv>
              </Grid>
            </Grid>
          </Box>
        </PaddTwentyFour>
      </Container>
    </WhyChooseUsDiv>
  )
}

export default WhyChooseUsSection
